const BACKEND = process.env.REACT_APP_BACKEND_URL;
const WIDTHS = [320, 480, 640];
const HERO_WIDTHS = [480, 640, 800, 1200];

// Stored images are served by /api/img; `w` requests a resized WebP, `fit` a center crop (4x5, 9x16, 16x9).
export const imgUrl = (url, w, fit) => {
  if (!url || !url.startsWith("/api/img/")) return url;
  const q = [w && `w=${w}`, w && fit && `fit=${fit}`].filter(Boolean).join("&");
  return `${BACKEND}${url}${q ? `?${q}` : ""}`;
};

// Variante large pour le visuel du premier écran (affiché jusqu'à ~800 px CSS).
export const heroImg = (url, fit, sizes) => {
  if (!url || !url.startsWith("/api/img/")) return { src: url };
  return {
    src: imgUrl(url, 800, fit),
    srcSet: HERO_WIDTHS.map((w) => `${imgUrl(url, w, fit)} ${w}w`).join(", "),
    sizes,
  };
};
export const cardImg = (url, fit, sizes) => {
  if (!url || !url.startsWith("/api/img/")) return { src: url };
  return {
    src: imgUrl(url, 640, fit),
    srcSet: WIDTHS.map((w) => `${imgUrl(url, w, fit)} ${w}w`).join(", "),
    sizes,
  };
};
